import { render, staticRenderFns } from "./client-bullhorn-error-block.vue?vue&type=template&id=29c99b40"
import script from "./client-bullhorn-error-block.vue?vue&type=script&lang=js"
export * from "./client-bullhorn-error-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports